import { render, staticRenderFns } from "./Region.vue?vue&type=template&id=124bcd36"
import script from "./Region.vue?vue&type=script&lang=js"
export * from "./Region.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('124bcd36')) {
      api.createRecord('124bcd36', component.options)
    } else {
      api.reload('124bcd36', component.options)
    }
    module.hot.accept("./Region.vue?vue&type=template&id=124bcd36", function () {
      api.rerender('124bcd36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/Region.vue"
export default component.exports